import { Dependency } from '../models/dependency.interface';

export interface DependencyState {
  dependencies: Dependency[];
  parentDependencies: Dependency[];
  selectedDependency: Dependency | null;
  searchResults: Dependency[];
  loading: boolean;
  creating: boolean;
  updating: boolean;
  toggling: boolean;
  searching: boolean;
  error: string | null;
}

export const initialDependencyState: DependencyState = {
  dependencies: [],
  parentDependencies: [],
  selectedDependency: null,
  searchResults: [],
  loading: false,
  creating: false,
  updating: false,
  toggling: false,
  searching: false,
  error: null
};
